import * as timeFilters from '@/filters/time'
import '@fortawesome/fontawesome-free/css/all.css'
import CurrencyField from 'dealerfinanceservices-shared/src/CurrencyField'
import DatePicker from 'dealerfinanceservices-shared/src/DatePicker'
import CurrencyFilter from 'dealerfinanceservices-shared/src/filters/currency'
import TextField from 'dealerfinanceservices-shared/src/TextField'
import Moment from 'moment'
import Vue from 'vue'
// import VueChartkick from 'vue-chartkick' // TODO remove these if we have no charts
// import Chart from 'chart.js'
import Vuelidate from 'vuelidate'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import App from './App.vue'
import nl from './assets/vuetify-i18n'
import router from './router'
import store from './store'
import wysiwyg from 'vue-wysiwyg'

require('./axios')

Moment.locale('nl_NL')

// Vue.use(VueChartkick, { adapter: Chart })
Vue.use(Vuetify, {
  lang: {
    locales: { nl },
    current: 'nl'
  },
  theme: {
    primary: '#00b333',
    accent: '#e9ecf2'
  },
  iconfont: 'fa'
})
Vue.use(require('vue-moment'))
Vue.use(Vuelidate)
Vue.use(wysiwyg, {
  hideModules: {
    bold: false,
    italic: false,
    underline: false,
    justifyLeft: true,
    justifyCenter: true,
    justifyRight: true,
    headings: true,
    link: true,
    code: true,
    orderedList: true,
    unorderedList: true,
    image: true,
    table: true,
    removeFormat: true,
    separator: true
  }
})

Vue.component('EuroField', CurrencyField)
Vue.component('TextField', TextField)
Vue.component('DatePicker', DatePicker)

Vue.filter('currency', CurrencyFilter)
Vue.filter('date', timeFilters.friendlyDateFilter)
Vue.filter('calendarDay', timeFilters.formatCalendarDay)
Vue.filter('calendarDayTime', timeFilters.formatCalendarDayTime)

Vue.config.productionTip = false

store.dispatch('auth/checkStorage')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

if (!process.env.VUE_APP_API_URL) {
  throw new Error('Missing env vars. Did you forget to set them?')
}
